<template>
  <header class="workspace__header">
    <!-- <a href="/" class="g-sw-home"> -->
    <a href v-on:click="moveToMain" class="g-sw-home">
      <div class="header__btn--home"></div>
    </a>

    <span class="header__btn__wrap">
        <button
          v-if="type !== 'runner' && !isJb"
          class="header__btn herder__btn--coding-party" @click="downManual"
        >
          교육자료 다운받기
        </button>
        <button class="header__btn header__btn--sound"
                v-bind:class="checkSoundEnable"
                v-on:click="toggleSound"></button>
        <button class="header__btn header__btn--full"
                v-on:click="toggleFullScreen"></button>
        <button class="header__btn header__btn--map"
                v-on:click="moveToMap"></button>
    </span>
  </header>
</template>

<script>
  export default {
    name: 'headerTemplate',
    props: ['userType', 'type', 'isJb'],
    data() {
      return {
        soundEnable: true
      }
    },
    computed: {
      /**
       *  @DESC   사운드 상태에 따른 아이콘 변경
       */
      checkSoundEnable() {
        return this.soundEnable ? 'on' : 'off';
      }
    },
    created() {
        window.addEventListener('beforeunload', this.parentRefresh)
    },
    mounted() {
        //window.addEventListener('beforeunload', this.parentRefresh)
    },
    beforeDestroy () {
        window.removeEventListener('beforeunload', this.parentRefresh)
    },
    methods: {
      closeWindow(){
        window.opener.location.reload()    // 오프너(ESOP 플랫폼 웹페이지) 강제 갱신 처리
      },
      /**
       *  @DESC 	사운드 토글
       */
      toggleSound() {
        this.soundEnable = (!this.soundEnable);
        document.cookie = `soundEnable=${this.soundEnable}; expires=Thur, 31 Dec 2099 23:59:59 UTC;`
        this.$emit('call_canvas_sound'); // toggleSound;
      },
      /**
       *  @DESC 	전체 화면
       */
      toggleFullScreen() {
        if ((document.fullScreenElement !== undefined && document.fullScreenElement === null)
          || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null)
          || (document.mozFullScreen !== undefined && !document.mozFullScreen)
          || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
          if (document.documentElement.requestFullScreen) {
            document.documentElement.requestFullScreen();
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
          } else if (document.documentElement.webkitRequestFullScreen) {
            document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
          } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen();
          }
        } else {
          if (document.cancelFullScreen) {
            document.cancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
      },
      /**
       *  @DESC 	메인으로 이동하기
       */
      moveToMain() {
        // 기존 코드 
        // location.href = this.getCookie('userType') === 'party'
        //   ? '/coding-party/list'
        //   : '/codmos/list'

        // 새창 띄워서 메인 이동
        //window.open(link, '_blank');
        //window.top.location.href = link;
        window.top.open('/', '_blank');

        // 놀이터 형태로 변경되면서 로직 수정(윈도우 닫기)        
        // window.opener.location.reload();    // 오프너(ESOP 플랫폼 웹페이지) 강제 갱신 처리
        // window.close();                     // 사전교육 학습창 닫기

        // // 코딩파티일 경우
        // if(this.userType === 'party'){

        // }
        // // 놀이터일 경우
        // else{
        //   // '/codmos/list'
        //   // window.top.location.href = link;
        // }
      },
      /**
       *  @DESC 	맵으로 이동하기
       */
      moveToMap() {
        // 기존 코드 
        // location.href = this.getCookie('userType') === 'party'
        //   ? '/coding-party/list'
        //   : '/codmos/list'

        // 놀이터 형태로 변경되면서 로직 수정(윈도우 닫기)        
        window.opener.location.reload();    // 오프너(ESOP 플랫폼 웹페이지) 강제 갱신 처리
        window.close();                     // 사전교육 학습창 닫기
      },
      downManual() {
        const DOWN = document.createElement('a')
        DOWN.setAttribute('href', '/codmos/static/assets/logicong-study-resources/doc/뚜앙과 함께하는 소프트웨어교육과정.hwp')
        DOWN.setAttribute('download', '')
        DOWN.click()
      }
    }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/stage/StagePartialHeader.vue